import { render } from "./Requirements.vue?vue&type=template&id=b2c5cc94"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__